import TempVehiclePictureModal from './temp-vehicle-picture-modal.vue'
export default TempVehiclePictureModal
